<template>
	<div class="f-datetime-local inputfield inputfield--text" v-if="field.name">
		<flat-pickr
		class="st-input"

		v-validate="getFieldValidation(field)"
		v-model="value"
			:disabled="systemdisable"
		:config="flatPickrConfig"
		:id="field.name"
		:name="field.name"
		:autocomplete="field.autocomplete"
		:placeholder="(field.placeholder ? $t(field.placeholder) : '')">
		</flat-pickr>
		<div class="error" v-show="errors.has(field.name)">
			{{ errors.first(field.name) }}
		</div>
	</div>
</template>

<script>
import fieldvalidation from '@/helpers/fieldvalidation';

import flatPickr from 'vue-flatpickr-component';
import { German } from "flatpickr/dist/l10n/de.js"
import 'flatpickr/dist/flatpickr.css';

export default {
	name: 'f-datetime-local',
    components: {
      flatPickr
    },
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return (field ? field.value : '');
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	if(field){
		    		field.value = value;
		    	} else {
		    		console.error('field not defined');
		    	}
		    }
		}
	},
	data(){
		let val = this.value;
		if(!val) val = new Date().getTime();

		return {
			flatPickrConfig: {
				dateFormat: "l, d.m.Y H:i",
				defaultDate: [val],
				minuteIncrement: 30,
				time_24hr: true,
				enableTime: true,
				locale: German
			}
		};
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-datetime-local.vue